import { atom } from "jotai";

export const respuestaCertificadoExpiradoAtom = atom("");
export const mostrarAlertaAtom=atom (false);